import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { ModulesSection } from '../components/ModulesSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
import { initPixel, trackPageView } from '../lib/pixel';
export function SalesPage() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0f1e] text-slate-200 font-sans selection:bg-[#25D366] selection:text-black" data-id="element-199">
      <HeroSection data-id="element-200" />
      <PainSection data-id="element-201" />
      <SolutionSection data-id="element-202" />
      <ModulesSection data-id="element-203" />
      <OfferSection data-id="element-204" />
      <FooterSection data-id="element-205" />
    </div>;
}